const template = document.createElement('template')
template.innerHTML = `
<div class="fvlib-notification-wrapper">
  <span class="fvlib-notification-label">Receive Flight Status Updates</span>
  <form id="fvlib-notification-form" action="" class="fvlib-notification-form">
    <input class="fvlib-notification-input" type="email" name="id0" placeholder="Enter your email address" required="">
    <input type="hidden" name="id1" value="">
    <input type="hidden" name="id2" value="">
    <input type="hidden" name="accept" value="on">
    <input type="hidden" name="lc" value="en">
    <input type="hidden" name="mailFormat" value="HTML">
    <input type="hidden" name="get" value="">
    <input type="hidden" name="ck0" value="">
    <input type="hidden" name="ck1" value="">
    <input type="hidden" name="ck2" value="">
    <input type="hidden" name="nlc" value="en">
    <button class="fvlib-notification-button" type="submit">Enter</button>
  </form>
  <span id="fvlib-notification-result"></span>
</div>
`

class FlightNotification extends HTMLElement {
  static observedAttributes = ['acccustid', 'nrid', 'al', 'fn', 'depap', 'depdateutc', 'untilarrival']

  createHiddenInput (name: string, value: string): HTMLElement {
    const hiddenInputElement = document.createElement('input')
    hiddenInputElement.type = 'hidden'
    hiddenInputElement.name = name
    hiddenInputElement.value = value
    return hiddenInputElement
  }

  onFormSubmit (e: SubmitEvent) {
    e.preventDefault()
    const formElement = e.target as HTMLFormElement
    const confirmationElement: HTMLElement = formElement.parentElement.querySelector('#fvlib-notification-result')
    confirmationElement.innerText = ''
    const formData = new FormData(formElement)
    fetch('https://tracker.flightview.com/FVAccess3/tools/notify/notifyjs.aspx', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(formData as any)
    }).then((response) => {
      if (response.status === 201) {
        confirmationElement.setAttribute('class', 'fvlib-notification-success')
        confirmationElement.innerText = 'You have successfully subscribed.'
      } else {
        confirmationElement.setAttribute('class', 'fvlib-notification-failure')
        confirmationElement.innerText = 'Cannot subscribe for the moment, please try again later.'
      }
    }).catch(() => {
      confirmationElement.setAttribute('class', 'fvlib-notification-failure')
      confirmationElement.innerText = 'Cannot subscribe for the moment, please try again later.'
    })
  }

  connectedCallback () {
    this.appendChild(document.importNode(template.content, true))
    const formElement = this.querySelector('#fvlib-notification-form')

    for (let i = 0; i < this.attributes.length; i++) {
      const attr = this.attributes.item(i)
      formElement.appendChild(this.createHiddenInput(attr.name, attr.value))
    }

    formElement.addEventListener('submit', this.onFormSubmit)
  }

  attributeChangedCallback (name: string, oldValue: string, newValue: string) {
    // no need to update if same value

    if (oldValue === newValue) return

    // check if the form is already there or not
    const formElement = this.querySelector('#fvlib-notification-form')
    if (!formElement) return

    // replace the input value if it already exists, create it otherwise
    let found = false
    for (const element of formElement.children) {
      if (element instanceof HTMLInputElement && element.name === name) {
        element.value = newValue
        found = true
        break
      }
    }
    if (!found) {
      formElement.appendChild(this.createHiddenInput(name, newValue))
    }
  }
}

window.customElements.define('flight-notification', FlightNotification)
